export enum TileStatusType {
  None = 'None',
  Training = 'Training',
  Test = 'Test',
  Independent = 'Independent'
}
